module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.update) ? _c('div', {
    staticClass: "trainers-notes"
  }, [_c('box', [_c('box-header', {
    attrs: {
      "title": !_vm.saving ? "TRAINER'S NOTES" : "TRAINER'S NOTES - SAVING..."
    }
  }), _vm._v(" "), _c('box-content', [_c('div', {
    staticClass: "form__group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.update.note),
      expression: "update.note"
    }],
    staticClass: "form-control form-control--no-border",
    attrs: {
      "disabled": _vm.saving,
      "placeholder": "Type here..."
    },
    domProps: {
      "value": (_vm.update.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.update, "note", $event.target.value)
      }
    }
  })])])], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19d071d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/TrainerNotes.vue
// module id = 1670
// module chunks = 2